import React from 'react';
import { connect } from 'dva';
import PropTypes from 'prop-types';
import actions from './actions';
import styles from './OverlaysContent.module.scss';
import OverlaySelectionRow from './SelectionRow'

const OverlaysContent = (props) => {
  return (
    <div className={styles.selectorContents}>
      {props.overlays.map((overlay, i) => {
        return (
          <OverlaySelectionRow
            activeOverlays={props.activeOverlays}
            key={i}
            onChange={props.onChange}
            overlay={overlay}
          />
        );
      })}
    </div>
  );
};

OverlaysContent.propTypes = {
  activeOverlays: PropTypes.array,
  onChange: PropTypes.func,
  overlays: PropTypes.array,
};

export default connect((model) => {
  return {
    activeOverlays: model.layers.overlays.filter(
      (overlay) => overlay.enabled == 1
    ),
    overlays: model.layers.overlays,
  };
}, actions)(OverlaysContent);
